import { useTranslation } from 'react-i18next'

export default function Version() {
    const { t } = useTranslation()
    return (
        <>
            v1.6 · 22/10/2026 12:06
        </>
    )
}